import React from "react";

import RoundButton from "../RoundButton";

import { Toolbar, useMediaQuery } from "@material-ui/core";
import { Footer } from "./styles";

import marcas from "../../assets/images/logos.png";

export default function (props) {
  const { replay, prev, next, logos, color } = props;
  const web = useMediaQuery("(min-width: 900px)");

  return (
    <>
      {logos ? (
        <Footer color={color} logos={true}>
          <img src={marcas} alt='Instituições responsáveis pelo curso' />
        </Footer>
      ) : (
        <Footer color={color}>
          <Toolbar>
            {replay ? (
              <RoundButton type='replay' to={replay} />
            ) : (
              <RoundButton disabled />
            )}
            {web ? (
              <>
                <div className='middlebutton'>
                  {prev ? (
                    <RoundButton type='previous' to={prev} />
                  ) : (
                    <RoundButton type='previous' opacity />
                  )}
                  {next ? (
                    <RoundButton type='next' to={next} margin />
                  ) : (
                    <RoundButton type='next' opacity margin />
                  )}
                </div>
                <div className='placeholder'>
                  <RoundButton disabled />
                </div>
              </>
            ) : (
              <>
                <div className='endbutton'>
                  {prev ? (
                    <RoundButton type='previous' to={prev} />
                  ) : (
                    <RoundButton type='previous' opacity />
                  )}
                  {next ? (
                    <RoundButton type='next' to={next} margin />
                  ) : (
                    <RoundButton type='next' opacity margin />
                  )}
                </div>
              </>
            )}
          </Toolbar>
        </Footer>
      )}
    </>
  );
}
